import {useDataProvider, useNotify, useQuery, useRefresh} from "react-admin";
import React from "react";
import {Button, Form, Input, InputNumber, Space, Switch, Typography} from "antd";
import {createSubmitHandler} from "@src/components/Settings/utils";
import {ExtendedDataProvider} from "@src/types";
const { Title, Paragraph} = Typography;


const ExternalAPISettingsForm = () => {
    const notify = useNotify();
    const [form] = Form.useForm ();
    const refresh = useRefresh();
    const dataProvider: ExtendedDataProvider = useDataProvider ()
    const settingsName = "ExternalAPISettings"
    const initRateLimit = 10;
    const initLimitResponsePerMinute = 5;

    const minRateLimit = 1;
    const maxRateLimit = 10;


    const {loaded, error, data: currentSettings} = useQuery ({
        type: 'getOne',
        resource: 'general_settings',
        payload: {id: settingsName}
    });

    return (
        <>
            {
                (loaded || error) &&
                <Form
                    form={form}
                    labelAlign='left'
                    colon={false}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 16}}
                    onFinish={createSubmitHandler(settingsName, currentSettings, dataProvider, notify, refresh)}
                >
                    <Typography>
                        <Paragraph>
                            The following settings help control the frequency of outbound webhook and healthcheck requests:
                        </Paragraph>
                    </Typography>

                    <Form.Item
                        label={
                            <Space orientation={"vertical"}>
                                Webhook Rate Limit Per Minute :
                                <div style={{ whiteSpace: 'pre-wrap', fontWeight: 'normal', color: '#888', fontSize: 12 }}>
                                    Maximum number of webhook requests sent per minute. Please enter a positive number between {minRateLimit} and {maxRateLimit}.
                                </div>
                            </Space>
                        }
                        style={{height: "90px"}}
                        initialValue={currentSettings?.['config']?.webhook_rate_limit_per_minute || initLimitResponsePerMinute}
                        name="webhook_rate_limit_per_minute"
                    >
                        <InputNumber min={minRateLimit} max={maxRateLimit} precision={0} style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        label={
                            <Space orientation={"vertical"}>
                                Webhook Response Rate Limit :
                                <div style={{ whiteSpace: 'pre-wrap', fontWeight: 'normal', color: '#888', fontSize: 12 }}>
                                    Maximum number of webhook responses saved in NetOrca. Please enter a positive number between {minRateLimit} and {maxRateLimit}.
                                </div>
                            </Space>
                        }
                        style={{height: "90px"}}
                        initialValue={currentSettings?.['config']?.webhook_response_rate_limit || initRateLimit}
                        name="webhook_response_rate_limit"
                    >
                        <InputNumber min={minRateLimit} max={maxRateLimit} precision={0} style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        label={
                            <Space orientation={"vertical"}>
                                Healthcheck Rate Limit Per Minute :
                                <div style={{ whiteSpace: 'pre-wrap', fontWeight: 'normal', color: '#888', fontSize: 12 }}>
                                    Controls how many healthcheck requests are made per minute. Please enter a positive number between {minRateLimit} and {maxRateLimit}.
                                </div>
                            </Space>
                        }
                        style={{height: "90px"}}
                        initialValue={currentSettings?.['config']?.healthcheck_rate_limit_per_minute || initLimitResponsePerMinute}
                        name="healthcheck_rate_limit_per_minute"
                    >
                        <InputNumber min={minRateLimit} max={maxRateLimit} precision={0} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item
                        label={
                            <Space orientation={"vertical"}>
                                Healthcheck Response Rate Limit :
                                <div style={{ whiteSpace: 'pre-wrap', fontWeight: 'normal', color: '#888', fontSize: 12 }}>
                                    Maximum number of healthcheck responses saved in NetOrca. Please enter a positive number between {minRateLimit} and {maxRateLimit}.
                                </div>
                            </Space>
                        }
                        style={{height: "90px"}}
                        initialValue={currentSettings?.['config']?.healthcheck_response_rate_limit || initRateLimit}
                        name="healthcheck_response_rate_limit"
                    >
                        <InputNumber min={minRateLimit} max={maxRateLimit} precision={0} style={{ width: '100%' }} />
                    </Form.Item>


                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="form-button">Save</Button>
                    </Form.Item>
                </Form>
            }
        </>
    )
}

export default ExternalAPISettingsForm;
